import { PitchSlide } from '../data/slides';
import { postJson, request } from './request';

export interface DeckSummary {
  id: string;
  name: string;
  designId: string;
  slideCount: number;
  firstSlide: PitchSlide | null;
  createdAt: string;
  updatedAt: string;
}

export interface Deck {
  id: string;
  name: string;
  designId: string;
  logoUrl: string | null;
  createdAt: string;
  updatedAt: string;
  slides: PitchSlide[];
}

export const listDecks = async (): Promise<DeckSummary[]> => {
  const data = await request<{ decks: DeckSummary[] }>('/api/decks');
  return data.decks;
};

export const getDeck = (id: string): Promise<Deck> => request<Deck>(`/api/decks/${id}`);

export interface CreateDeckInput {
  name: string;
  designId?: string;
  logoUrl?: string | null;
  slides: PitchSlide[];
  pitchTemplateId?: string;
}

export const createDeck = (input: CreateDeckInput): Promise<Deck> =>
  postJson<Deck>('/api/decks', input);

export interface UpdateDeckInput {
  name?: string;
  designId?: string;
  logoUrl?: string | null;
  slides?: PitchSlide[];
}

export const updateDeck = (id: string, input: UpdateDeckInput): Promise<Deck> =>
  request<Deck>(`/api/decks/${id}`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(input),
  });

export interface GenerateDeckInput {
  prompt: string;
  templateId: string;
  name?: string;
}

export const generateDeck = (input: GenerateDeckInput): Promise<Deck> =>
  postJson<Deck>('/api/generate-deck', input);
